// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__GNUuk","footer":"Form_footer__39vyA"};